import { useCallback } from "react"
import { useError } from "../../context/useErrorContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { EPixKeyType } from "../../Enum/EPixKeyType"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { useTranslation } from "react-i18next"

export interface ResellerProfile {
  resellerId: number
  name: string
  email: string | null
  phoneNumber: string | null
  documentCpfCnpj: string
  status: EEnableStatusType
  referralCode: string
  hasCompletedProfile: boolean
  pixKeyType: EPixKeyType
  pixKey: string | null
  bankName: string | null
  bankAgency: string | null
  bankAccount: string | null
  bankAccountHolderName: string | null
}

export const useGetResellerProfile = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetResellerProfile = useCallback(async (onSuccess: (profile: ResellerProfile) => void) => {
    try {
      const response = await GetRequest<ResellerProfile>(API_ROUTES.RESELLER.ME, ERequestType.Reseller)

      if (response.success && response.data) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }, [setError, t])

  return { handleGetResellerProfile }
}
